import * as yup from "yup"

import {
  BackdropCircularProgress,
  EmailFieldRHF,
  EnhancedDropDownRHFWithLabel,
  EnhancedMultiDropDownRHFWithLabel,
  EnhancedSnackbar,
  ExtensionNumberRHF,
  IEnhancedDropDownItem,
  ITest,
  LabelPosition,
  PhoneNumberRHF,
  PostCodeRHF,
  RHookFormDatePicker,
  RHookFormMaskedTextFieldWithLabel,
  RHookFormTextFieldWithLabel,
  SinNumberRHF,
  SingleColumnLayout,
  StandardPanel,
  StandardSubmitFormButtonsToolbar,
} from "@websential/cosmic";
import { Box, Grid } from "@mui/material";
import { DataRoleService, TaxSlipYearService } from "../../../services";
import {
  EMPLOYEE_RESOURCE_LITERAL,
  FILING_RESOURCE_SETUP_SCREEN_ID,
  FILING_RESOURCE_SETUP_SCREEN_SLUG,
  GET_QUERY_KEY,
  INITIAL_PAGE_SIZE,
  INITIAL_SNACKBAR_DATA,
  QUERY_OPTIONS,
} from "../../../common/constants";
import { FC, useEffect, useMemo, useState } from "react";
import { FilingResourceSetupSchema, hasRole } from "./validator";
import { FormProvider, useForm } from "react-hook-form";
import {
  IDataRoleRequestPayload,
  IDataRoleResponsePayload,
  IGetListRequest,
  IResponse,
  IServerError,
} from "../../../models";
import { instanceOfIFillingResourceResponce, instanceOfIResource } from "../../../common/instance-method";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";

import { CountryService } from "../../../services/common/CountryService";
import { FilingResourceService } from "../../../services/FilingResourceService";
import { IAppState } from "../../../store/reducers";
import { ICountryReferenceModel } from "../../../models/country/ICountryReferenceModel";
import { IFilingResourceRequestPayload } from "../../../models/filingResource/IFilingResourceRequestPayload";
import { IProvinceReferenceModel } from "../../../models/province/IProvinceReferenceModel";
import { ProvinceService } from "../../../services/common/ProvinceService";
import { ResourceService } from "../../../services/ResourceService";
import { T4SlipService } from "../../../services/T4SlipService";
import { checkSINValidity } from "../../T4Slip/T4SlipSetup/validator";
import { setSelectedActivityLogActions } from "../../../store/actions/activityLogActions";
import { setSelectedStickyNavBar } from "../../../store/actions/stickyNavBarActions";
import { startsWith } from "lodash";
import { yupResolver } from "@hookform/resolvers/yup";

export interface IFilingResourceSetup extends ITest { }
const SINGLE_RECORD_DATA_QUERY_KEY = "filling-resource-single-data-record";

// const useGetData = (id: string | undefined, clientId: string) => {
//   return useQuery(
//     [SINGLE_RECORD_DATA_QUERY_KEY, id],
//     () => FilingResourceService.getById(id, clientId),
//     QUERY_OPTIONS
//   );
// };

const useGetData = (id: string | undefined, clientId: string) =>
  useQuery({
    queryKey: [`single-filing-resource-data`, id, clientId],
    queryFn: (data) => {
      return FilingResourceService.getById(id, clientId);
    },
    refetchOnWindowFocus: false
  });

const contactPersonId = 1;
const issuerId = 2;
const transmitterId = 3;
// export let issuerSelectedValidate = false;

//years list from API
const useYears = (params: IGetListRequest) =>
  useQuery({
    queryKey: ["years-list", params],
    queryFn: (data) => {
      return TaxSlipYearService.getList(params);
    },
    refetchOnWindowFocus: false
  });

const EMPLOYEE_DDL_DATA_QUERY_KEY = "employee-ddl-data-record";


const useGetEmployeeDDLItems = (clientId: string, dataRole: string, taxYear: number) =>
  useQuery({
    queryKey: [EMPLOYEE_DDL_DATA_QUERY_KEY, clientId, dataRole, taxYear],
    queryFn: (data) => {
      return T4SlipService.getEmployeeDDL(clientId, dataRole, taxYear);
    },
    refetchOnWindowFocus: false,
  });

// export let currentTaxYear = new Date().getFullYear()

export const FilingResourceSetup: FC<IFilingResourceSetup> = ({ testId }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const clientName = useSelector((state: IAppState) => state.client.clientName);
  const taxYear = useSelector((state: IAppState) => state.taxYear.year);
  const isLoadingActivityLogData = useSelector(
    (state: IAppState) => state.isLoadAxiosCall.isLoading
  );
  // currentTaxYear = taxYear;
  const dashboardApiData = useSelector((state: IAppState) => state.dashboardApisData)
  const [issuerSelected, setIssuerSelected] = useState<boolean>(false);
  const [employeeData, setEmployeeData] = useState<any>(undefined);
  const [isPending, setIsPending] = useState<boolean>(false);
  const [firstNameDisabled, setFirstNameDisabled] = useState<boolean>(false);
  const [selectedProvince, setSelectedProvince] =
    useState<IProvinceReferenceModel>({
      name: "",
      shortCode: "",
    });

  const [CountryResponse] = useState<ICountryReferenceModel>({
    id: 1,
    name: "Canada",
    shortCode: "CAN",
  });

  // for edit
  const queryClient = useQueryClient();
  const { id } = useParams();


  const [transmitterSelected, setTransmitterSelected] =
    useState<boolean>(false);
  const clientId = useSelector((state: IAppState) => state.client.id);
  const DEFAULT_VALUES = {
    // clientId: clientId,
    // id: null,
    // name: "",
    // effectiveFromYear: undefined,
    // phone1: "",
    // ext: null,
    // role: ["6173ddf7-68e2-426f-b1be-9d1dd63eb49c"],
    // ownerSin1: "",
    // ownerSin2: null,
    // craTransmitter: "",
    // rqTransmitter: null,
    // rl1Type: null,
    // address: "",
    // city: "",
    // postCode: "",
    // contactName: "",
    // email: "",
    // province:{}
    id: undefined,
    name: "",
    effectiveFromYear: undefined,
    phone1: "",
    ext: "",
    role: ["6173ddf7-68e2-426f-b1be-9d1dd63eb49c"],
    ownerSin1: "",
    craTransmitter: "",
    rqTransmitter: "",
    rl1Type: "",
    address: "",
    city: "",
    postCode: "",
    contactName: "",
    email: "",
    province: undefined,
    country: undefined,
  };
  const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
  const { isPending: isSubmitting, mutate: submitFormData } = useMutation({
    mutationFn: FilingResourceService.create,

    onSuccess: (
      res: IFilingResourceRequestPayload | IServerError | IResponse | any
    ) => {
      if (instanceOfIFillingResourceResponce(res)) {
        queryClient.invalidateQueries();
        queryClient.invalidateQueries({
          queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, res.id],
        });
      }
      if (res.status === 201 || res.status === 200) {
        setSnackbarData({
          open: true,
          message: "Filing Resource has been added successfully",
          severity: "success",
        });
        setTimeout(() => {
          let path = "/filing-resources/list";
          navigate(path);
        });
      } else {
        setSnackbarData({
          open: true,
          message:
            res && res.data.message && typeof res.data.message !== "object"
              ? res.data.message
              : res.data.message.message
                ? res.data.message.message
                : "Data has been submitted successfully!",
          severity:
            res.data.status === false
              ? "error"
              : res.data.success === false
                ? "error"
                : "success",
        });
      }
    },
    onError: (err) => {
      // TODO: customize the toast message based on the response
      setSnackbarData({
        open: true,
        message: "An error occurred, please try again",
        severity: "error",
      });
    },
  }
  );

  // for edit
  const { isPending: isLoadingData, data: selectedFillingResourceData } =
    useGetData(id, clientId);

  //get years list by API
  const [queryParams, setQueryParams] = useState<IGetListRequest>({
    search_query: "",
    order_by: "role_name",
    order_direction: "asc",
    page: 1,
    size: INITIAL_PAGE_SIZE,
  });

  const { isPending: isPendingEmployeeDDLItems, data: employeeDDLItems } =
    useGetEmployeeDDLItems(clientId, EMPLOYEE_RESOURCE_LITERAL, taxYear);


  const { isLoading, data } = useYears(queryParams); //useQuery('accountants-list', AccountantService.getAccountantList, refetchOnWindowFocus: false);
  const YearsGetList: any = data;


  const yearItems = useMemo(() => {
    if (YearsGetList) {
      return YearsGetList.items.map((yearItem: any) => ({
        label: String(yearItem.year),
        value: yearItem.year,
      }));
    }
  }, [YearsGetList]);

  // const ExtendedValidationSchema = FilingResourceSetupSchema.shape({
  //   transmitterAccountNumber: yup
  //     .string()
  //     .nullable()
  //     .when("role", (role: any, schema) => {
  //       if (
  //         Array.isArray(role) &&
  //         role.includes("6173ddf7-68e2-426f-b1be-9d1dd63eb49e")
  //       ) {
  //         return schema.test(
  //           "is-valid-or-not",
  //           "Invalid Account Number",
  //           function (value) {
  //             if (value) {
  //               const maxLength = 15;
  //               const firstNineDigits = value.substring(0, 9);
  //               const output = checkSINValidity(firstNineDigits);

  //               if (value.length === maxLength && output % 10 === 0) {
  //                 return true;
  //               } else {
  //                 return this.createError({
  //                   message: "Invalid Account Number",
  //                   path: this.path,
  //                 });
  //               }
  //             }
  //             return true;
  //           }
  //         );
  //       }
  //       return schema.nullable();
  //     }),

  //   representativeId: yup
  //     .string()
  //     .nullable()
  //     .when("role", (role: any, schema) => {
  //       if (
  //         Array.isArray(role) &&
  //         role.includes("6173ddf7-68e2-426f-b1be-9d1dd63eb49e")
  //       ) {
  //         return schema.max(7, "Representative Id has at most 7 characters");
  //       }
  //       return schema.nullable();
  //     }),
  // });

  const ROLE_TRANSMITTER = "6173ddf7-68e2-426f-b1be-9d1dd63eb49e";

  const ExtendedValidationSchema = FilingResourceSetupSchema.shape({
    craTransmitter: yup
      .string()
      .test(
        "craTransmitter-test",
        "CRA Transmitter is required!",
        function (value) {
          const { role } = this.parent;

          if (taxYear <= 2023 && hasRole(role, ROLE_TRANSMITTER)) {
            console.log('value', value)
            if (value && value.startsWith("M") && value.length < 8) {
              return this.createError({
                message: "CRA Transmitter is required! Minimum 8 characters",
              });
            } else if (!value || value.length < 6) {
              return this.createError({
                message: "CRA Transmitter is required! Minimum 8 characters",
              });
            }
          }

          return true;
        }
      ),
    transmitterAccountNumber: yup
      .string()
      .nullable()
      .test(
        "transmitterAccountNumber-test",
        "Invalid Account Number",
        function (value) {
          const { role } = this.parent;

          // Not required unless TRANSMITTER role is selected
          if (!Array.isArray(role) || !role.includes(ROLE_TRANSMITTER)) {
            return true;
          }

          // Optional field (only validate if value exists)
          if (!value) return true;

          const maxLength = 15;
          const firstNineDigits = value.substring(0, 9);
          const output = checkSINValidity(firstNineDigits);

          if (value.length === maxLength && output % 10 === 0) {
            return true;
          }

          return this.createError({
            message: "Invalid Account Number",
            path: this.path,
          });
        }
      ),

    representativeId: yup
      .string()
      .nullable()
      .test(
        "representativeId-test",
        "Representative Id has at most 7 characters",
        function (value) {
          const { role } = this.parent;

          if (
            Array.isArray(role) &&
            role.includes(ROLE_TRANSMITTER) &&
            value &&
            value.length > 7
          ) {
            return this.createError({
              message: "Representative Id has at most 7 characters",
              path: this.path,
            });
          }

          return true;
        }
      ),
  });


  const formMethods: any = useForm<any>({
    resolver: yupResolver(ExtendedValidationSchema),
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: DEFAULT_VALUES,
  });

  const onSubmit = (formData: any) => {

    if (dashboardApiData.masked_status && employeeData && !id) {
      setSnackbarData({
        open: true,
        message: "Please Unmask your data to submit!",
        severity: "warning",
      })
    } else {
      //province is in string format and by using this we convert that in object
      const jsonString =
        formData.province !== undefined && ""
          ? formData.province
          : ('{id:9, name: "Ontario",shortCode:"ON"}' as string);
      // Custom parsing function to convert the JSON-like string to an object
      const parseJSONLikeString = (str: string) => {
        // Use regular expressions to add double quotes around keys and string values
        const modifiedString = str.replace(/(\w+):/g, '"$1":').replace(/'/g, '"');
        // Convert the modified JSON string to an object using JSON.parse()
        return JSON.parse(modifiedString);
      };
      // Convert the JSON-like string to an object
      const provinceObject = parseJSONLikeString(jsonString);


      // const maskedStatus: any = sessionStorage.getItem("maskEnabled");




      const requestPayload: IFilingResourceRequestPayload = {
        // clientId: formData.clientId,
        clientId: clientId,
        id: selectedFillingResourceData
          ? selectedFillingResourceData.id
          : undefined,
        name: formData.name,
        effectiveFromYear: parseInt(formData.effectiveFromYear),
        phone1: formData.phone1 && formData.phone1.replace(/\D/g, ""),
        ext: formData.ext !== "" ? formData.ext : undefined,
        role: formData.role,
        ownerSin1:
          selectedFillingResourceData &&
            selectedFillingResourceData.id &&
            dashboardApiData.masked_status === true
            ? "000000000"
            : formData.ownerSin1 && issuerSelected ? formData.ownerSin1.replace(/-/g, "") : undefined,
        ownerSin2:
          formData.ownerSin2 !== "" && issuerSelected
            ? formData.ownerSin2 && formData.ownerSin2.replace(/-/g, "")
            : undefined,
        transmitterAccountNumber: taxYear > 2023 && transmitterSelected && formData.transmitterAccountNumber ? formData.transmitterAccountNumber : undefined,
        representativeId: taxYear > 2023 && transmitterSelected && formData.representativeId ? formData.representativeId : undefined,
        craTransmitter: formData.craTransmitter && transmitterSelected
          && formData.craTransmitter.length === 6
          ? `MM${formData.craTransmitter}` : formData.craTransmitter.length === 8
            ? `${formData.craTransmitter}` : undefined,
        rqTransmitter:
          formData.rqTransmitter !== "" && formData.rqTransmitter !== undefined && transmitterSelected
            && formData.rqTransmitter.length === 6
            ? `NP${formData.rqTransmitter}`
            : formData.rqTransmitter.length === 8
              ? `${formData.rqTransmitter}`
              : undefined,
        rl1Type:
          formData.rl1Type !== "" && formData.rl1Type !== undefined && transmitterSelected
            ? formData.rl1Type
            : undefined,
        address: formData.address && transmitterSelected ? formData.address : undefined,
        city: formData.city && transmitterSelected ? formData.city : undefined,
        postCode:
          formData.postCode && transmitterSelected ?
            formData.postCode.replace(/[a-z]/g, (match: string) =>
              match.toUpperCase()
            ) : undefined,
        contactName: formData.contactName && transmitterSelected ? formData.contactName : undefined,
        email: formData.email && transmitterSelected ? formData.email : undefined,
        // province: formData.province,
        province: transmitterSelected ? provinceObject : undefined,
        country: transmitterSelected ? CountryResponse : undefined,
      };


      if (taxYear > 2023 && transmitterSelected && !requestPayload.transmitterAccountNumber && !requestPayload.representativeId) {
        setSnackbarData({
          open: true,
          message: "Either the Transmitter Account Number or Representative ID is required.",
          severity: "error",
        });
      } else {
        submitFormData(requestPayload);
      }
    }

  };

  const initialState = () => {
    formMethods.reset(DEFAULT_VALUES);
    setIssuerSelected(false)
    setTransmitterSelected(false)
    setEmployeeData(undefined)
    let path = `/filing-resources/setup`;
    navigate(path);
  }
  const onResetClicked = () => {
    setSnackbarData({
      open: true,
      message: "Form was reset successfully",
      severity: "success",
    });
    initialState()
  };

  const onSnackbarClosed = (
    _event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarData(INITIAL_SNACKBAR_DATA);
  };

  const onSelectionChangeHandler = (selectedItems: IEnhancedDropDownItem[]) => {

    if (selectedItems.length === 1) {
      if (selectedItems.find((item) => item.id === 1)) {
        setIssuerSelected(false);
        setTransmitterSelected(false);
      } else if (selectedItems.find((item) => item.id === 2)) {
        setIssuerSelected(true);
        setTransmitterSelected(false);
      } else if (selectedItems.find((item) => item.id === 3)) {
        // setIssuerSelected(true);
        setIssuerSelected(false);
        setTransmitterSelected(true);
      }
    } else if (selectedItems.length === 2) {
      if (
        selectedItems.find((item) => item.id === 1) &&
        selectedItems.find((item) => item.id === 2)
      ) {

        setIssuerSelected(true);
        setTransmitterSelected(false);
      } else if (
        selectedItems.find((item) => item.id === 1) &&
        selectedItems.find((item) => item.id === 3)
      ) {

        // setIssuerSelected(true);
        setIssuerSelected(false);
        setTransmitterSelected(true);
      } else if (
        selectedItems.find((item) => item.id === 2) &&
        selectedItems.find((item) => item.id === 3)
      ) {

        setIssuerSelected(true);
        setTransmitterSelected(true);
      }
    } else if (selectedItems.length === 3) {
      if (selectedItems.find((item) => item.id === 1 && 2 && 3)) {
        setIssuerSelected(true);
        setTransmitterSelected(true);
      }
    } else if (selectedItems.length === 0) {
      setIssuerSelected(false);
      setTransmitterSelected(false);
    }
    // setIssuerSelected(
    //   selectedItems.findIndex((obj) => obj.id === issuerId || transmitterId) !== -1
    // );

    // setTransmitterSelected(
    //   selectedItems.findIndex((obj) => obj.id === transmitterId) !== -1
    // );
  };


  const useGetProvinceDDL = () => {
    return useQuery({
      queryKey: [GET_QUERY_KEY.PROVINCE_DDL],
      queryFn: () => ProvinceService.get(),
      ...QUERY_OPTIONS,
    });
  };

  const { isPending: isLoadingProvinceDropDownList, data: provinceList } =
    useGetProvinceDDL();

  // const onProvinceSelectionChangeHandler = (item: IEnhancedDropDownItem) => {
  //   setSelectedProvince({
  //     name: item.label,
  //     shortCode: String(item.value),
  //   });
  // };

  // for edit
  useEffect(() => {
    // if the selected flex field data has loaded.
    if (selectedFillingResourceData) {
      setFirstNameDisabled(true);
      Object.keys(selectedFillingResourceData).forEach((fieldName) => {

        // @ts-ignore
        const fieldValue = selectedFillingResourceData[fieldName];

        // @ts-ignore
        if (typeof fieldValue !== "object") {
          // @ts-ignore
          formMethods.setValue(
            fieldName,
            fieldValue && fieldValue !== null ? fieldValue : undefined
          );
        }
        if (fieldName === "role") {
          // @ts-ignore
          formMethods.setValue(fieldName, fieldValue ?? undefined);
          if (fieldValue.includes("6173ddf7-68e2-426f-b1be-9d1dd63eb49d")) {
            setIssuerSelected(true);
          }
          if (fieldValue.includes("6173ddf7-68e2-426f-b1be-9d1dd63eb49e")) {
            setTransmitterSelected(true);
          }
        }
        if (fieldName === "province") {
          let id = fieldValue.id;
          let name = fieldValue.name;
          let shortCode = fieldValue.shortCode;


          formMethods.setValue(
            fieldName,
            // '{id:9, name: "Ontario",shortCode:"ON"}'
            `{id:${id}, name: "${name}",shortCode:"${shortCode}"}`
          );
        }
        if (fieldName === "country") {
          // if (objFieldValue.name === "Canada") {
          formMethods.setValue(fieldName, fieldValue.name ?? undefined);
          // }
        }
        if (fieldName === "ownerSin1") {
          const formattedNumber = fieldValue
            ? fieldValue.replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3")
            : undefined;
          formMethods.setValue("ownerSin1", formattedNumber);
        }
        if (fieldName === "ownerSin2") {
          const formattedNumber = fieldValue
            ? fieldValue.replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3")
            : undefined;
          formMethods.setValue("ownerSin2", formattedNumber);
        }
        if (fieldName === "phone1") {
          const formattedNumber = fieldValue
            ? fieldValue.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")
            : undefined;
          formMethods.setValue("phone1", formattedNumber);
        }
      });
    }
  }, [selectedFillingResourceData, formMethods.setValue, formMethods]);

  const onEmployeeSelectionChangeHandler = async (selectedItem: any) => {
    // console.log("sdvc", selectedItem.value)
    if (selectedItem.value !== "") {
      (async () => {
        try {
          setIsPending(true)
          const response: any = await ResourceService.getById(selectedItem.value, EMPLOYEE_RESOURCE_LITERAL, clientId);
          if (response) {
            setEmployeeData(response)
            formMethods.setValue('name', `${response.name1} ${response.name2}`)
            formMethods.setValue('address', response.address[0].addressLine1)
            formMethods.setValue('ownerSin1', response.uniqueIdentifier)
            formMethods.setValue('email', response.email)
            formMethods.setValue('city', response.address[0].city)
            formMethods.setValue('postCode', response.address[0].postalCode)
            formMethods.setValue('contactName', `${response.name1} ${response.name2}`)
            const phoneNo = response.metaFields && response.metaFields.find((x: any) => x.name === "phoneNo")
            // console.log('phoneNophoneNophoneNo', phoneNo)
            if (phoneNo) {
              formMethods.setValue('phone1', phoneNo.value)
            }
            if (response.address[0].province) {
              let id = response.address[0].province.id;
              let name = response.address[0].province.name;
              let shortCode = response.address[0].province.shortCode;


              formMethods.setValue(
                "province",
                `{id:${id}, name: "${name}",shortCode:"${shortCode}"}`
              );
            }
          }
        }
        catch { } finally { setIsPending(false) }
      })();
    } else {
      initialState()
    }
  }

  useEffect(() => {
    dispatch(
      setSelectedActivityLogActions({
        entityId1: id ? id : "",
        entityId2: "",
        entityId3: "",
        screenName: FILING_RESOURCE_SETUP_SCREEN_SLUG,
        companyName: clientName,
        activityType:
          "activity_type=create&activity_type=updated",
        activityLogVisibility: true,
      })
    );
    dispatch(setSelectedStickyNavBar({ isSticky: true }));
  }, []);

  return (
    <Grid
      size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
      sx={{ "& .MuiAppBar-root": { zIndex: 2, top: "65px" } }}
    >
      <BackdropCircularProgress
        // open={isSubmitting}
        open={
          isLoadingProvinceDropDownList ||
          isSubmitting ||
          isLoadingData ||
          isLoadingActivityLogData ||
          isPending ||
          isPendingEmployeeDDLItems
        }
        testId={`${testId}-backdrop`}
      />
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(onSubmit)}>
          <SingleColumnLayout
            children={
              <>
                <StandardPanel
                  title="Resource Information"
                  testId={`${testId}-resource-information`}
                >
                  <EnhancedMultiDropDownRHFWithLabel
                    selectName="role"
                    label="Role"
                    labelPosition={LabelPosition.Left}
                    items={[
                      {
                        id: 1,
                        label: "Contact Person",
                        value: "6173ddf7-68e2-426f-b1be-9d1dd63eb49c",
                      },
                      {
                        id: 2,
                        label: "Issuer",
                        value: "6173ddf7-68e2-426f-b1be-9d1dd63eb49d",
                      },
                      {
                        id: 3,
                        label: "Transmitter",
                        value: "6173ddf7-68e2-426f-b1be-9d1dd63eb49e",
                      },
                      // { label: "Contact Person",value: 1},
                      // {label: "Issuer",value: 2},
                      // {label: "Transmitter",value: 3},
                    ]}
                    selectedItems={["6173ddf7-68e2-426f-b1be-9d1dd63eb49c"]}
                    isClearable={false}
                    testId={`${testId}-selected-roles`}
                    onSelectionChangeHandler={onSelectionChangeHandler}
                    required
                  />
                  <EnhancedDropDownRHFWithLabel
                    selectName="employee"
                    label="Employee"
                    labelPosition={LabelPosition.Left}
                    items={employeeDDLItems ?? []}
                    onSelectionChangeHandler={onEmployeeSelectionChangeHandler}
                    showEmpty
                    testId={"employee-ddl"}
                  />
                  <EnhancedDropDownRHFWithLabel
                    selectName="effectiveFromYear"
                    label="Effective From"
                    labelPosition={LabelPosition.Left}
                    items={yearItems ? yearItems : []}
                    testId={`${testId}-effective-from`}
                    required
                  />
                  <RHookFormTextFieldWithLabel
                    label="Name"
                    id="name"
                    testId={`${testId}-name`}
                    labelPosition={LabelPosition.Left}
                    readOnly={firstNameDisabled}
                    required
                  />
                  <Box sx={{ pb: 2 }}></Box>
                  <Grid
                    container
                    columnSpacing={0}
                    size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                  >
                    <Grid size={{ xs: 8, sm: 8, md: 8, lg: 8, xl: 8 }}>
                      <PhoneNumberRHF
                        label="Phone"
                        id="phone1"
                        testId={`${testId}-phone`}
                        labelPosition={LabelPosition.Left}
                        labelColumns={6}
                        fieldColumns={6}
                        required
                      />
                      {/* <RHookFormTextFieldWithLabel
                        label="Phone"
                        id="phone1"
                        placeholder="(777) 777-777"
                        testId={`${testId}-phone`}
                        labelPosition={LabelPosition.Left}
                        labelColumns={6}
                        fieldColumns={6}
                        required
                      /> */}
                    </Grid>
                    <Grid size={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}></Grid>
                    <Grid size={{ xs: 3, sm: 3, md: 3, lg: 3, xl: 3 }}>
                      <ExtensionNumberRHF
                        label="Ext."
                        id="ext"
                        testId={`${testId}-ext`}
                        labelPosition={LabelPosition.Left}
                        labelColumns={6}
                        fieldColumns={6}
                      />
                      {/* <RHookFormTextFieldWithLabel
                        label="Ext."
                        id="ext"
                        testId={`${testId}-ext`}
                        labelPosition={LabelPosition.Left}
                        labelColumns={6}
                        fieldColumns={6}
                      /> */}
                    </Grid>
                  </Grid>
                </StandardPanel>
                {issuerSelected && (
                  <StandardPanel
                    id="issuerPanel"
                    title="Other Details for Issuer"
                    testId={`${testId}-other-details-issuer`}
                    topPadding={2}
                  >
                    {selectedFillingResourceData &&
                      selectedFillingResourceData.ownerSin1 &&
                      selectedFillingResourceData.ownerSin1.charAt(2) === "*" ? (
                      <RHookFormTextFieldWithLabel
                        label="Owner SIN 1"
                        id="ownerSin1"
                        testId={`${testId}-owner-sin-1`}
                        labelPosition={LabelPosition.Left}
                        required
                        labelColumns={4}
                        fieldColumns={8}
                        readOnly={selectedFillingResourceData ? true : false}
                        value={"Unmask to view / edit"}
                      />
                    ) : (
                      <SinNumberRHF
                        label="Owner SIN 1"
                        id="ownerSin1"
                        testId={`${testId}-owner-sin-1`}
                        labelPosition={LabelPosition.Left}
                        required
                        labelColumns={4}
                        fieldColumns={8}
                      />
                    )}
                    <SinNumberRHF
                      label="Owner SIN 2"
                      id="ownerSin2"
                      testId={`${testId}-owner-sin-2`}
                      labelPosition={LabelPosition.Left}
                      labelColumns={4}
                      fieldColumns={8}
                    />
                    {/* <RHookFormTextFieldWithLabel
                      label="Owner SIN 1"
                      id="ownerSin1"
                      testId={`${testId}-owner-sin-1`}
                      labelPosition={LabelPosition.Left}
                      required
                    /> */}
                    {/* <RHookFormTextFieldWithLabel
                      label="Owner SIN 2"
                      id="ownerSin2"
                      testId={`${testId}-owner-sin-2`}
                      labelPosition={LabelPosition.Left}
                    /> */}
                  </StandardPanel>
                )}
                {transmitterSelected && (
                  <>
                    <StandardPanel
                      title="Other Details for Transmitter"
                      testId={`${testId}-other-details-transmitter`}
                      topPadding={2}
                    >
                      {taxYear > 2023 ? <RHookFormMaskedTextFieldWithLabel
                        id='transmitterAccountNumber'
                        label='Account Number'
                        labelPosition={LabelPosition.Left}
                        testId='accountNumber'
                        // required={requiredAccountNumber}
                        labelColumns={4}
                        fieldColumns={8}
                        placeholder={"000000000RP0000"}
                        inputMaskPattern={"{000000000Ra0000}"}
                      // defaultValue={"123123123RT0000"}
                      /> : <></>}
                      {taxYear > 2023 ? <RHookFormTextFieldWithLabel
                        id='representativeId'
                        label='Representative Id'
                        labelPosition={LabelPosition.Left}
                        testId='representativeId'
                        // required={!requiredAccountNumber}
                        labelColumns={4}
                        fieldColumns={8}
                        placeholder={"1234567"}
                      /> : <></>}
                      {taxYear <= 2023 ? <RHookFormMaskedTextFieldWithLabel
                        label="CRA Transmitter #"
                        id="craTransmitter"
                        testId={`${testId}-cra-transmitter-number`}
                        labelPosition={LabelPosition.Left}
                        placeholder={"MM123456"}
                        required
                        inputMaskPattern={"MM000000"}
                        labelColumns={4}
                        fieldColumns={8}
                      /> : <></>}
                      <RHookFormMaskedTextFieldWithLabel
                        label="RQ Transmitter #"
                        id="rqTransmitter"
                        testId={`${testId}-rq-transmitter-number`}
                        labelPosition={LabelPosition.Left}
                        placeholder={"NP123456"}
                        // required
                        inputMaskPattern={"NP000000"}
                        labelColumns={4}
                        fieldColumns={8}
                      />
                      {/* <RHookFormTextFieldWithLabel
                        label="CRA Transmitter #"
                        id="craTransmitter"
                        testId={`${testId}-cra-transmitter-number`}
                        labelPosition={LabelPosition.Left}
                        placeholder="MM123456"
                        required
                      /> */}
                      {/* <RHookFormTextFieldWithLabel
                        label="RQ Transmitter #"
                        id="rqTransmitter"
                        testId={`${testId}-rq-transmitter-number`}
                        labelPosition={LabelPosition.Left}
                        placeholder="NP123456"
                      /> */}
                      <EnhancedDropDownRHFWithLabel
                        selectName="rl1Type"
                        label="RL-1 Type"
                        labelPosition={LabelPosition.Left}
                        items={[
                          {
                            label: "If you are filing for yourself",
                            value: "if you are filing for yourself",
                          },
                          {
                            label:
                              "If you are filing on behalf of other filers",
                            value:
                              "if you are filing on behalf of other filers",
                          },
                          {
                            label:
                              "If you are filing for yourself and on behalf of other filers",
                            value:
                              "if you are filing for yourself and on behalf of other filers",
                          },
                        ]}
                        testId={`${testId}-rl1-type`}
                      />
                      <RHookFormTextFieldWithLabel
                        label="Address"
                        id="address"
                        testId={`${testId}-transmitter-address`}
                        labelPosition={LabelPosition.Left}
                        required
                      />
                      <RHookFormTextFieldWithLabel
                        label="City"
                        id="city"
                        testId={`${testId}-transmitter-city`}
                        labelPosition={LabelPosition.Left}
                        required
                      />
                      <EnhancedDropDownRHFWithLabel
                        selectName="province"
                        label="Province"
                        // selectedItem={selectedProvince.shortCode}
                        labelPosition={LabelPosition.Left}
                        required
                        testId={`${testId}-transmitter-province`}
                        items={provinceList ?? []}
                      // onSelectionChangeHandler={
                      //   onProvinceSelectionChangeHandler
                      // }
                      />
                      {/* <EnhancedDropDownRHFWithLabel
                        selectName="province"
                        label="Province"
                        labelPosition={LabelPosition.Left}
                        required
                        testId={`${testId}-province-list`}
                        items={[
                          {
                            label: "Alberta",
                            value: { id: 1, name: "Alberta", shortCode: "AB" },
                          },
                          {
                            label: "British Columbia",
                            value: {
                              id: 2,
                              name: "British Columbia",
                              shortCode: "BC",
                            },
                          },
                          {
                            label: "Manitoba",
                            value: { id: 3, name: "Manitoba", shortCode: "MB" },
                          },
                          {
                            label: "New Brunswick",
                            value: {
                              id: 4,
                              name: "New Brunswick",
                              shortCode: "NB",
                            },
                          },
                          {
                            label: "NewfoundLand and Labrador",
                            value: {
                              id: 5,
                              name: "NewfoundLand and Labrador",
                              shortCode: "NL",
                            },
                          },
                          {
                            label: "Northwest Territories",
                            value: {
                              id: 7,
                              name: "Northwest Territories",
                              shortCode: "NT",
                            },
                          },
                          {
                            label: "Nova Scotia",
                            value: {
                              id: 6,
                              name: "Nova Scotia",
                              shortCode: "US",
                            },
                          },
                          {
                            label: "Nunavut",
                            value: { id: 8, name: "Nunavut", shortCode: "NU" },
                          },
                          {
                            label: "Ontario",
                            value: { id: 9, name: "Ontario", shortCode: "ON" },
                          },
                          {
                            label: "Prince Edward Island",
                            value: {
                              id: 10,
                              name: "Prince Edward Island",
                              shortCode: "PE",
                            },
                          },
                          {
                            label: "Quebec",
                            value: { id: 11, name: "Quebec", shortCode: "QC" },
                          },
                          {
                            label: "Saskatchewan",
                            value: {
                              id: 12,
                              name: "Saskatchewan",
                              shortCode: "SK",
                            },
                          },
                          {
                            label: "Yukon",
                            value: { id: 13, name: "Yukon", shortCode: "YT" },
                          },
                        ]}
                      /> */}
                      {/* <EnhancedDropDownRHFWithLabel
                        selectName="province"
                        label="Province"
                        labelPosition={LabelPosition.Left}
                        items={[
                          { label:"Alberta", value:1},
                          {
                            label: "British Columbia",
                            value: 2,
                          },
                          {
                            label: "Manitoba",
                            value: 3,
                          },
                          {
                            label: "New Brunswick",
                            value: 4,
                          },
                          {
                            label: "NewfoundLand and Labrador",
                            value: 5,
                          },
                          {
                            label: "Northwest Territories",
                            value: 6,
                          },
                          {
                            label: "Nova Scotia",
                            value: 7,
                          },
                          {
                            label: "Nunavut",
                            value: 8,
                          },
                          {
                            label: "Ontario",
                            value: 9,
                          },
                          {
                            label: "Prince Edward Island",
                            value: 10,
                          },
                          {
                            label: "Quebec",
                            value: 11,
                          },
                          {
                            label: "Saskatchewan",
                            value: 12,
                          },
                          {
                            label: "Yukon",
                            value: 13,
                          },
                        ]}
                        testId={`${testId}-transmitter-province`}
                        required
                      /> */}

                      <RHookFormTextFieldWithLabel
                        label="Country"
                        id="country"
                        testId={`${testId}-transmitter-country`}
                        labelPosition={LabelPosition.Left}
                        value="Canada"
                        defaultValue={"Canada"}
                        readOnly
                      />
                      <PostCodeRHF
                        label="Post Code"
                        id="postCode"
                        testId={`${testId}-transmitter-post-code`}
                        labelPosition={LabelPosition.Left}
                        required
                        labelColumns={4}
                        fieldColumns={8}
                      />
                      {/* <RHookFormTextFieldWithLabel
                        label="Post Code"
                        id="postCode"
                        testId={`${testId}-transmitter-post-code`}
                        labelPosition={LabelPosition.Left}
                        required
                      /> */}
                      <RHookFormTextFieldWithLabel
                        label="Contact Name"
                        id="contactName"
                        testId={`${testId}-transmitter-contact-name`}
                        labelPosition={LabelPosition.Left}
                        required
                      />
                      {/* <RHookFormTextFieldWithLabel
                        label="Email"
                        id="email"
                        testId={`${testId}-transmitter-email`}
                        labelPosition={LabelPosition.Left}
                        required
                        /> */}
                      <EmailFieldRHF
                        label="Email"
                        id="email"
                        testId={`${testId}-transmitter-email`}
                        labelPosition={LabelPosition.Left}
                        labelColumns={4}
                        fieldColumns={8}
                        required
                      />
                    </StandardPanel>
                  </>
                )}
              </>
            }
            toolbar={
              <StandardSubmitFormButtonsToolbar
                onResetClicked={onResetClicked}
                isSubmitting={false}
                testId="standard-form-submit-toolbar"
              />
            }
            testId="form-layout"
          />
        </form>
      </FormProvider>
      <EnhancedSnackbar
        message={snackbarData.message}
        onCloseHandler={onSnackbarClosed}
        severity={snackbarData.severity}
        testId={`${testId}-snackbar`}
        open={snackbarData.open}
      />
    </Grid>
  );
};
